import React from 'react';

function Tab2({tab, setTab, exchangeRateData, isSubmitting}) {
    return (
        <div className="form mt-0 mt-lg-10" id="kt_form">
            <div
                className="pb-5"
                data-wizard-type="step-content"
                data-wizard-state={tab === 2 ? "current" : ""}
            >
                {/* <!--begin::Section--> */}
                <h4 className="mb-10 font-weight-bold text-dark">Review Theme Details and Submit</h4>
                <h6 className="font-weight-bolder mb-3">Basic Details:</h6>
                <div className="text-dark-50 line-height-lg">
                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-6">
                            From Currency: <h6 className="d-inline px-3">{exchangeRateData?.fromCurrency}</h6>
                        </div>
                        <div className="col-xl-6">
                            To Currency: <h6 className="d-inline px-3">{exchangeRateData?.toCurrency}</h6>
                        </div>
                    </div>
                    {/* <!--end::Input--> */}
                    <div className="row">
                        <div className="col-xl-6">
                            Rate: <h6 className="d-inline px-3">{exchangeRateData?.rate}</h6>
                        </div>
                        <div className="col-xl-6">
                            User Group: <h6 className="d-inline px-3">{exchangeRateData?.userGroup}</h6>
                        </div>
                    </div>
                    {/* <!--end::Input--> */}
                </div>
                {/* <!--end::Section--> */}

                {/* <!--begin: Wizard Actions--> */}
                <div className="d-flex justify-content-between border-top mt-5 pt-10">
                    <div className="mr-2">
                        <button
                            onClick={_ => setTab(1)}
                            type="button"
                            className="btn btn-light-primary font-weight-bolder text-uppercase px-9 py-4">Previous
                        </button>
                    </div>
                    <div>
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="btn btn-success font-weight-bolder text-uppercase px-9 py-4"
                        >

                            {
                                isSubmitting ?
                                    <div className="spinner-border spinner-border-sm mx-5 text-white" role="status">
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    "Submit"
                            }
                        </button>
                    </div>
                </div>
                {/* <!--end: Wizard Actions--> */}
            </div>
        </div>
    );
}

export default Tab2;